module.exports = __webpack_public_path__ + "img/大厂管件.2ee13f59.jpg";